// extracted by mini-css-extract-plugin
module.exports = {"arrow":"styles-module--arrow--1Ympz"};